const initialState = null;
const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'USER/SET':
            return action.payload;
        case 'USER/UNSET':
            return initialState;
        default:
            return state;
    }
};


export default userReducer